<template>
  <div id="notFound" class="f_c_c f-d-c h-100 w-100">
    <b-img class="mb-5" :src="require(`@/assets/images/404.svg`)" fluid></b-img>
    <div class="text c1d9dae mb-5 fn-1-2rem">
      متاسفانه صفحه مورد نظر شما پیدا نشد
    </div>
    <div class="returnHomePageBtn" @click="returnHomePageFunc()">
      بازگشت به صفحه اصلی
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NotFound",
  computed: {
    ...mapState({
      loginStates: (state) => state.login,
    }),
    user() {
      return this.loginStates.user;
    },
  },
  methods: {
    returnHomePageFunc() {
      if (this.user.token) {
        this.$router.push({ name: "weekly" });
      } else {
        this.$router.push({ name: "auth" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#notFound {
  img {
    width: 50%;
    height: 50%;
  }
  .text {
  }
  .returnHomePageBtn {
    padding: 10px 20px;
    background-color: #9bf1fc;
    color: #006e7f;
    border-radius: 20px;
    font-size: 1rem;
    cursor: pointer;
  }
}
@media (max-width: 1000px) {
  #notFound {
    img {
      width: 65%;
    }
    .text {
    }
    .returnHomePageBtn {
    }
  }
}
</style>